"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExerciseCardMobile = exports.setTrainingRatingTag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const tags_1 = require("../../atoms/tags");
const ExerciseSeriesParameters_1 = require("./ExerciseSeriesParameters");
// TODO: change api in shared-components
const setTrainingRatingTag = (rating, noRatingTranslation) => {
    switch (rating) {
        case "Hard":
        case "Zwaar":
            return (0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "red", children: rating }, void 0);
        case "Medium":
        case "Middel":
            return (0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "yellow", children: rating }, void 0);
        case "Easy":
        case "Makkelijk":
            return (0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "green", children: rating }, void 0);
        default:
            return (0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "silver", children: noRatingTranslation }, void 0);
    }
};
exports.setTrainingRatingTag = setTrainingRatingTag;
const ExerciseCardMobile = (props) => {
    var _a;
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("img", { src: props.img, alt: props.translations.image.altText }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: props.translations.exerciseName }, void 0), (0, exports.setTrainingRatingTag)(props.exerciseData.exerciseRating || "", props.translations.rating)] }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: props.translations.exerciseDesc }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: props.translations.exerciseRest }, void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(HistoryGroup, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ExerciseSeriesParameters_1.ExerciseSeriesParameters, { seriesData: props.exerciseData.seriesData }, void 0) }, void 0) }, void 0), ((_a = props.exerciseData.note) === null || _a === void 0 ? void 0 : _a.body) && ((0, jsx_runtime_1.jsx)(NoteWrapper, { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: props.exerciseData.note.body }, void 0) }, void 0))] }, void 0));
};
exports.ExerciseCardMobile = ExerciseCardMobile;
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  padding: ${({ theme }) => theme.spacings.m};

  h2,
  p {
    margin-bottom: 0;
    line-height: 1.5rem;
  }

  & img {
    height: 87px;
    width: 105px;
  }

  & > div:first-of-type {
    display: flex;
  }

  & > div:first-of-type > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    margin-left: ${({ theme }) => theme.spacings.m};

    div:first-of-type {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }

  h2 + span {
    margin-right: 0;
  }
`;
const HistoryGroup = styled_components_1.default.div `
  border-top: 1px solid ${({ theme }) => theme.colors.silverLighten70};
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacings.m};
  padding-top: ${({ theme }) => theme.spacings.m};
  & > div {
    display: flex;
    flex-direction: column;

    & > div {
      display: flex;
      justify-content: space-between;
    }
  }
`;
const NoteWrapper = styled_components_1.default.div `
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  margin: ${({ theme }) => `${theme.spacings.m} 0 0`};
  padding: ${({ theme }) => theme.spacings.m};
`;
//# sourceMappingURL=ExerciseCardMobile.js.map